
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 5.734V4.695H9.79v1.04H.164zm.008-3.132A4.482 4.482 0 011.227 1.07 2.193 2.193 0 012.78.453c.625 0 1.37.274 2.235.82.864.547 1.52.82 1.968.82.443 0 .813-.116 1.11-.35.297-.235.596-.6.898-1.095l.625.422c-.224.464-.578.933-1.062 1.407-.485.468-1.073.703-1.766.703-.667 0-1.43-.274-2.289-.82-.854-.547-1.508-.82-1.96-.82-.381 0-.714.119-1 .358-.287.24-.54.589-.759 1.047l-.61-.343z","fill":"currentColor"}})])
          )
        }
      }
    